export type ExternalSsoNavigator = (loginUrl: string) => void;

export const launchExternalSsoLogin = (
  loginUrl: string,
  navigate: ExternalSsoNavigator,
  currentLocation: Pick<Location, 'pathname' | 'search'> = window.location,
): void => {
  const url = new URL(loginUrl);
  url.searchParams.set(
    'next',
    `${currentLocation.pathname}${currentLocation.search}`,
  );
  navigate(url.toString());
};
